import * as moment from 'moment';

moment.locale(process.env.VUE_APP_MOMENT_LOCALE || 'de');

// Checks if the given date is in the current week.
export const isInCurrentWeek = (givenDate, startWeekDate) => {
    return givenDate.isBetween(startWeekDate, startWeekDate.clone().add(1, 'week'), null, '(]');
};

// Checks if the given date is in the current week including the first day.
export const isInCurrentWeekIncludingFirstDay = (givenDate, startWeekDate) => {
    return givenDate.isBetween(startWeekDate, startWeekDate.clone().add(1, 'week'), null, '[)');
};

// Checks if the given date is already in an array with objects containing date key.
export const isObjectWithDateInArray = (dateString, array) => {
    return array.reduce((accumulator, value) => value.date === dateString || accumulator, false);
};

// Checks if the given date is already in current week defined by an array with objects containing date key.
export const includesDayInCurrentWeek = (day, array) => {
    return array.reduce((doesContainDay, value) => {
        return isInCurrentWeek(day, moment(value.date)) || doesContainDay;
    }, false);
};

// Checks if the given date is already in current week defined by an array with objects containing date key, but date has ID set to null.
export const includesDayWithNoIdInCurrentWeek = (day, array) => {
    return array.reduce((doesContainDay, value) => {
        return (isInCurrentWeek(day, moment(value.date)) && value.id === null) || doesContainDay;
    }, false);
};

// Checks if the given date is already in the given array with objects containing date key.

export const includesDay = (day, array) => {
    return array.reduce((value) => {
        return moment(value.date).isSame(day);
    }, false);
};

export const formatDisplayDate = (date) => {
    const momentDate = moment(date);
    const formattedDate = momentDate.format('dddd Do MMMM');
    return formattedDate;
};
export const formatDisplayDateForRestartStep = (date) => {
    const momentDate = moment(date);
    const formattedDate = momentDate.format('dddd, MM/DD/YY');
    return formattedDate;
};
